import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

export default function ProductDetails(props) {

  return (
    <Row>
      <Col sm="6" className="mt-2">
        <span dangerouslySetInnerHTML={{ __html: props.productDescription }} />
      </Col>

      <Col sm="6" className="mt-2">
        <p>
          <strong>Product Information</strong>
        </p>
        <ul dangerouslySetInnerHTML={{ __html: props.productInformation }} />
      </Col>
    </Row>
  );
}

ProductDetails.propTypes = {
  productDescription: PropTypes.string.isRequired,  
  productInformation: PropTypes.string,
};
